export enum UserRoleEnum {
  ADMIN = 'ADM',
  DG = 'DG',
  EXM = 'EXM',
  SHO = 'SHO',
  DEO = 'DEO',
  PYO = "PYO",
  SCO = "SCO",
}
